const minin = {
  data() {
    return {
      baseUrl: 'staff',
      viewMode: false,
      form: {
        name: undefined,
        sex: '男',
        birthday: undefined,
        tel: undefined,
        nation: undefined,
        province: undefined,
        address: undefined,
        contact: undefined,
        contacttel: undefined,
        identitycard: undefined,
        username: undefined,
        password: undefined,
      },
      rules: {
        name: [
          { required: true, message: "请填写姓名", trigger: "blur" },
        ],
        birthday: [
          { required: true, message: "请选择出生年月", trigger: "blur" },
        ],
        tel: [
          { required: true, validator: this.checkPhone, trigger: "blur" },
        ],
        // nation: [
        //   { required: true, message: "请填写民族", trigger: "blur" },
        // ],
        // province: [
        //   { required: true, message: "请填写籍贯", trigger: "blur" },
        // ],
        address: [
          { required: true, message: "请填写住址", trigger: "blur" },
        ],
        // contact: [
        //   { required: true, message: "请填写紧急联系人姓名", trigger: "blur" },
        // ],
        // contacttel: [
        //   { required: false, validator: this.checkPhone, trigger: "blur" },
        // ],
        username: [
          { required: true, message: "请填写用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请填写密码", trigger: "blur" },
          { min: 6, message: "长度不小于 6 位", trigger: "blur" },
        ],
      },
      formGroups: [
        {
          title: '基础信息',
          formCtrl: [
            {
              label: "姓名",
              keyName: "name",
              err: "请填写姓名",
              type: "text",
            },
            {
              label: "性别",
              keyName: "sex",
              err: "请选择性别",
              type: "select",
              options: [
                { label: '男', value: '男' },
                { label: '女', value: '女' },
              ],
            },
            {
              label: "出生年月",
              keyName: "birthday",
              err: "请选择出生年月",
              type: "date",
            },
            {
              label: "入职时间",
              keyName: "entrytime",
              err: "请选择入职时间",
              type: "date",
            },
            {
              label: "状态",
              keyName: "iswork",
              err: "请选择状态",
              type: "select",
              options: [],
            },
            {
              label: "学历",
              keyName: "edu",
              err: "请选择学历",
              type: "select",
              options: [],
            },
            {
              label: "联系方式",
              keyName: "tel",
              err: "请填写联系方式",
              type: "text",
            },
            {
              label: "民族",
              keyName: "nation",
              err: "请选择民族",
              type: "select",
              options: [],
            },
            {
              label: "籍贯",
              keyName: "province",
              err: "请填写籍贯",
              type: "text",
            },
            {
              label: "住址",
              keyName: "address",
              err: "请填写住址",
              type: "text",
            },
            {
              label: "紧急联系人",
              keyName: "contact",
              err: "请填写紧急联系人姓名",
              type: "text",
            },
            {
              label: "紧急联系人联系方式",
              keyName: "contacttel",
              err: "请填写紧急联系人联系方式",
              type: "text",
            },
            {
              label: "身份证正反面",
              keyName: "identitycard",
              type: "file",
              ptype: "person",
              tips: "最多上传2张图片",
              max: 2,
              className: "block",
            },
          ],
        },
        {
          title: '账号信息',
          formCtrl: [
            {
              label: "用户名",
              keyName: "username",
              err: "请填写用户名",
              type: "text",
            },
            {
              label: "密码",
              keyName: "password",
              err: "请填写密码",
              type: "password",
            },
          ],
        },
      ],
    };
  },
  methods: {
    getOptions(params = {}) {
      this.post(`${this.baseUrl}/addpro`, params, this.setOptions, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setOptions({ iswork, edu }) {
      // console.log([...this.NATION])
      this.formGroups[0].formCtrl.map(c => {
        if (c.keyName == 'nation' && this.NATION) {
          // console.log({...c})
          c.options = this.NATION.map(v => {
            return {
              label: v.name,
              value: v.name,
            }
          })
          // 没有姓名说明是新建信息
          if (!this.form.name) this.form.nation = this.NATION[0].name
          // console.log([...c.options])
          // console.log({...this.form})
        } else if (c.keyName == 'iswork' && iswork) {
          for (const key in iswork) {
            if (Object.hasOwnProperty.call(iswork, key)) {
              const val = iswork[key];
              c.options.push({
                label: val,
                value: key,
              })
            }
          }
          if (!this.form.name) this.form.iswork = '1'
          // console.log([...c.options])
          // console.log({...this.form})
        } else if (c.keyName == 'edu' && edu.length) {
          c.options = edu.map(v => {
            return {
              label: v.eduname,
              value: v.eduname,
            }
          })
          if (!this.form.name) this.form.edu = edu[0].eduname
        }
      })
    },
    setDetail() {
      const formCtrl = [...this.formGroups[0].formCtrl]
      if (this.formGroups[1]) {
        formCtrl.push(...this.formGroups[1].formCtrl)
      }
      formCtrl.map(v => {
        const key = v.keyName
        if (['iswork'].includes(key)) {
          this.form[key] = this.detail[key] + ''
        } else {
          this.form[key] = this.detail[key];
        }
      })
      this.$forceUpdate()
      console.log({ ...this.detail })
      console.log({ ...this.form })
    },
    // 非必填验证手机号
    checkPhoneFun(value) {
      const phoneRegExp = /^1[3|4|5|6|7|8|9][0-9]{9}$/
      const fixPhoneRegExp = /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/
      // console.log(value)
      if (value == undefined || value == '') {
        // return (new Error('请填写联系方式'));
        return true;
      } else if (!phoneRegExp.test(value) && !fixPhoneRegExp.test(value)) {
        return false;
      } else {
        return true;
      }
    },
    formOrtherValidate() {
      // console.log(this.checkedIds)
      // console.log(this.checkedIds.length)
      let boo = true
      const { contacttel } = this.form
      // console.log(contacttel)
      // console.log(this.checkPhoneFun(contacttel))
      if (contacttel && !this.checkPhoneFun(contacttel)) {
        this.$message({
          type: 'error',
          message: '请填写正确的紧急联系人联系方式！'
        });
        boo = false
      }
      return boo
    },
  },
  mounted() {
    if (this.mode === 'edit' && this.formGroups[1]) {
      this.formGroups[1].formCtrl.map(c => {
        if (c.keyName == 'username') {
          c.disabled = true
        }
      })
    }
  },
}

export default minin